import uuid from 'uuid';
import { axios } from 'ynf-core-middleware';

export const axiosInstance = axios.create({
  baseURL: window._YMSHOST_ || window.__MAIN_ORIGIN__,
  timeout: 20000
});

export const getFileOperationUrl = function (appCode, authId = '') {
  const id = uuid();
  return `/iuap-apcom-file/rest/v1/file/${appCode}/${id}/upload?fromDevice=web&authId=${authId}`
}